import React from 'react';
import { MDBBtn } from "mdbreact";
import firebase from '../firebase';
const logOutUser = () => {
  firebase.auth().signOut();
};
const LogOut = () => {
  return <MDBBtn onClick={logOutUser} outline color="secondary" size="sm" children="Salir" />;
};
export default LogOut;